import { http } from '@/api/http'
import type { Category, StationKey } from '@/lib/pos-types'
import { normalizeCategory, unwrapList, unwrapSingle } from '@/api/normalizers'

export const categoriesApi = {
  list: async (): Promise<Category[]> => {
    const res = await http.get<unknown>('/categories')
    return unwrapList(res.data).map(normalizeCategory)
  },
  create: async (payload: { name: string; sortOrder?: number; stationKey?: StationKey | null }): Promise<Category> => {
    const data = {
      name: payload.name,
      sort_order: payload.sortOrder,
      ...(payload.stationKey !== undefined && { station_key: payload.stationKey }),
    }
    const res = await http.post<unknown>('/categories', data)
    return normalizeCategory(unwrapSingle(res.data))
  },
  update: async (categoryId: string, payload: { name?: string; sortOrder?: number; stationKey?: StationKey | null }): Promise<Category> => {
    const data = {
      ...(payload.name !== undefined && { name: payload.name }),
      ...(payload.sortOrder !== undefined && { sort_order: payload.sortOrder }),
      ...(payload.stationKey !== undefined && { station_key: payload.stationKey }),
    }
    const res = await http.patch<unknown>(`/categories/${categoryId}`, data)
    return normalizeCategory(unwrapSingle(res.data))
  },
  delete: async (categoryId: string): Promise<void> => {
    await http.delete(`/categories/${categoryId}`)
  },
}
